import { render, staticRenderFns } from "./ContentLogoWallBlock.vue?vue&type=template&id=4910fe60&scoped=true"
import script from "./ContentLogoWallBlock.vue?vue&type=script&lang=js"
export * from "./ContentLogoWallBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentLogoWallBlock.vue?vue&type=style&index=0&id=4910fe60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910fe60",
  null
  
)

export default component.exports